import React, { useEffect, useState, useCallback } from "react";
import "./../Styles/PaymentDetails.css";
import { API } from "./../../config/api";

export default function PaymentDetails() {
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);

  const user = JSON.parse(sessionStorage.getItem("user") || "{}");

  // ================= FETCH PAYMENTS =================
  const fetchPayments = useCallback(
    async (from = "", to = "") => {
      try {
        if (!user?.id) return;

        setLoading(true);

        let url = `${API.BASE_URL}/api.php?action=get_designer_payments_user&designer_id=${user.id}`;

        if (from) url += `&from_date=${from}`;
        if (to) url += `&to_date=${to}`;

        const res = await fetch(url);
        const data = await res.json();

        if (data.status) {
          setPayments(data.payments || []);
        } else {
          setPayments([]);
        }
      } catch (err) {
        console.error("Payment Fetch Error:", err);
        setPayments([]);
      } finally {
        setLoading(false);
      }
    },
    [user?.id],
  );

  // ================= INITIAL LOAD =================
  useEffect(() => {
    fetchPayments();
  }, [fetchPayments]);

  return (
    <div
      className="container-fluid min-vh-100 py-4 px-3 px-md-5"
      style={{
        backgroundColor: "#F8F9FA",
        fontFamily:
          "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        color: "#1E293B",
      }}
    >
      {/* ================= HEADER ================= */}
      <div className="d-flex flex-column flex-md-row align-items-md-center justify-content-between pb-3 mb-4 border-bottom gap-3">
        <div>
          <h2
            className="fw-bold m-0 text-dark"
            style={{ letterSpacing: "-0.5px" }}
          >
            Payment History
          </h2>
          <p className="text-muted small mb-0 mt-1">
            View and filter your past transaction records.
          </p>
        </div>

        {/* Minimal Total Summary Box */}
      </div>

      {/* ================= FULL-WIDTH TABLE ================= */}
      <div className="card border-0 shadow-sm rounded-1 p-0 overflow-hidden bg-white">
        {loading ? (
          <div className="text-center py-5">
            <div
              className="spinner-border spinner-border-sm text-secondary"
              role="status"
            ></div>
            <p className="text-muted mt-2 mb-0 small">Loading payments...</p>
          </div>
        ) : payments.length === 0 ? (
          <div className="text-center py-5">
            <h6 className="fw-semibold text-dark mb-1">No payments found</h6>
            <p className="text-muted small mb-0">
              No records matched the selected date range.
            </p>
          </div>
        ) : (
          <div className="table-responsive w-100 m-0">
            <table className="table table-hover align-middle mb-0 w-100">
              <thead className="bg-light border-bottom">
                <tr className="text-center">
                  <th
                    className="py-3 px-4 text-uppercase text-muted fw-semibold"
                    style={{
                      fontSize: "11px",
                      letterSpacing: "0.5px",
                      width: "70px",
                    }}
                  >
                    #
                  </th>
                  <th
                    className="py-3 px-4 text-uppercase text-muted fw-semibold"
                    style={{ fontSize: "11px", letterSpacing: "0.5px" }}
                  >
                    Payment Date
                  </th>
                  <th
                    className="py-3 px-4 text-uppercase text-muted fw-semibold"
                    style={{ fontSize: "11px", letterSpacing: "0.5px" }}
                  >
                    Amount
                  </th>
                  <th
                    className="py-3 px-4 text-uppercase text-muted fw-semibold"
                    style={{ fontSize: "11px", letterSpacing: "0.5px" }}
                  >
                    Method
                  </th>

                  <th
                    className="py-3 px-4 text-uppercase text-muted fw-semibold"
                    style={{ fontSize: "11px", letterSpacing: "0.5px" }}
                  >
                    Details
                  </th>
                </tr>
              </thead>

              <tbody>
                {payments.map((p, index) => (
                  <tr key={p.id || index} className="border-bottom">
                    <td className="py-3 px-4 text-muted small">
                      {payments.length - index}
                    </td>

                    <td className="py-3 px-4 text-dark small fw-medium">
                      {new Date(p.payment_date).toLocaleDateString("en-IN", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                      })}
                    </td>

                    <td className="py-3 px-4 fw-bold text-dark fs-6">
                      ₹
                      {Number(p.amount).toLocaleString("en-IN", {
                        minimumFractionDigits: 2,
                      })}
                    </td>

                    <td className="py-3 px-4">
                      <span
                        className="badge px-2.5 py-1.5 fw-medium rounded-2"
                        style={{
                          backgroundColor:
                            p.payment_type === "Cash"
                              ? "#E6F4EA"
                              : p.payment_type === "UPI"
                                ? "#E8F0FE"
                                : "#F1F3F4",
                          color:
                            p.payment_type === "Cash"
                              ? "#137333"
                              : p.payment_type === "UPI"
                                ? "#1A73E8"
                                : "#3C4043",
                          fontSize: "12px",
                        }}
                      >
                        {p.payment_type || "Cash"}
                      </span>
                    </td>

                    <td className="py-3 px-4">{p.notes || "-"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
